import rect from '@/common-pages/leaderboard/assets/jackpot-rect.png';
import oldIcon from '../assets/daily-icon.webp';
import pkIcon from '@/pages/vs-leaderboard/assets/vs-icon.webp';
import {goTo} from '@utils';
import React from 'react';
import {LeaderboardType} from '@/common-pages/leaderboard/config';
import {useShowLeaderboardRect} from '@/common-pages/leaderboard/hooks/useShowLeaderboardRect';

const typeIconMap: Record<LeaderboardType, string> = {
  NEW_USER_RANK_ACTIVITY: rect,
  FISSION_RANK_ACTIVITY: rect,
  OLD_USER_RANK_ACTIVITY: oldIcon,
  PK_RANK_ACTIVITY: pkIcon,
};
export default function LeaderboardRect({type}: {type: LeaderboardType}) {
  const leaderTypes = useShowLeaderboardRect();
  const shouldShowRect = leaderTypes[type];
  if (!shouldShowRect) {
    return null;
  }
  return (
    <div
      className="size-14 z-10 bg-no-repeat"
      style={{
        backgroundImage: `url(${typeIconMap[type]})`,
        backgroundSize: '100% 100%',
      }}
      onClick={() => {
        goTo('Leaderboard', {
          type,
        });
      }}
      role="presentation"
      aria-hidden="true"
    />
  );
}
